"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _actions = require("../../redux/actions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const {
  ComponentTypes,
  regularByDeviceProductCodeList
} = _paulCorePackage.constants;
const FlushTabs = () => {
  const activeDeviceId = (0, _reactRedux.useSelector)(_selectors.selectActiveDeviceId) || null;
  const dispatch = (0, _reactRedux.useDispatch)();
  const devicesById = (0, _reactRedux.useSelector)(_selectors.selectDevicesById);
  const devices = (0, _paulCorePackage.useDeepMemo)(() => Object.values(devicesById).filter(item => item.equipmentType === ComponentTypes.PwcPoe && regularByDeviceProductCodeList.smartValveFlush.test(item.thingPaulProductCode)), [devicesById]);
  const handleChange = (0, _paulCorePackage.useDeepCallback)((_, index) => {
    devices.find((device, i) => i === index && dispatch((0, _actions.setActiveDeviceId)(device.thingPDIDDevice)));
  }, [dispatch, devices]);
  const activeTab = (0, _react.useMemo)(() => {
    const index = devices.findIndex(d => d.thingPDIDDevice === activeDeviceId);
    return index === -1 ? 0 : index;
  }, [devices, activeDeviceId]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tabs, {
    value: activeTab,
    onChange: handleChange,
    centered: false,
    variant: "scrollable",
    scrollButtons: "auto",
    "aria-label": "scrollable auto tabs example",
    sx: {
      '& .MuiTab-root': {
        fontFamily: "var(--main-font-family) !important",
        fontWeight: 'bold'
      },
      '& .MuiTabs-flexContainer': {
        justifyContent: 'center'
      }
    }
  }, devices.map((device, index) => {
    var _device$thingDeviceAd;
    return /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tab, {
      key: device.thingPDIDDevice,
      label: "Filter ".concat((_device$thingDeviceAd = device.thingDeviceAddress) !== null && _device$thingDeviceAd !== void 0 ? _device$thingDeviceAd : '-'),
      disabled: false,
      index: index
    });
  })), [devices, activeTab]);
};
var _default = exports.default = FlushTabs;